import { render, staticRenderFns } from "./_base-push-notification-toggle.vue?vue&type=template&id=9e84bb8c&scoped=true"
import script from "./_base-push-notification-toggle.vue?vue&type=script&lang=js"
export * from "./_base-push-notification-toggle.vue?vue&type=script&lang=js"
import style0 from "./_base-push-notification-toggle.vue?vue&type=style&index=0&id=9e84bb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e84bb8c",
  null
  
)

export default component.exports